module.exports = __webpack_public_path__ + "./fonts/GrenettePro-Light.otf";